
export type GetTweetById200Stats = {
  likes?: number;
  replies?: number;
  retweets?: number;
  views?: number;
};
